'use client';

import { ReactNode } from 'react';

import { IconInfoCircle } from '@tabler/icons-react';
import { VenueBookingType } from '@types';
import { clsx } from 'clsx';

import { RichText } from '../rich-text';

export const TabContent = ({
  description,
  additionalNotes,
  children,
}: Omit<VenueBookingType, 'title' | 'component'> & { children: ReactNode }) => (
  <div className={clsx('flex h-full min-h-96 flex-col gap-3 transition')}>
    <div className="flex flex-col gap-2">
      {description && <RichText className="text-sm">{description.content}</RichText>}
      {Boolean(additionalNotes?.content.length) && (
        <div className="border-muted-foreground/10 text-muted-foreground bg-muted/10 flex items-center gap-2 rounded-sm border px-2 py-1">
          <IconInfoCircle size={20} className="opacity-50" />
          <RichText className="text-xs font-medium">{additionalNotes?.content}</RichText>
        </div>
      )}
    </div>
    {children}
  </div>
);
